<template>
    <!-- SearchList.vue -->
    <v-list class="py-0">
        <!-- Loading Spinner -->
        <div class="text-center">
            <v-progress-circular
                v-if="loading"
                class="my-2"
                color="primary"
                indeterminate
                width="2"
            ></v-progress-circular>
        </div>

        <!-- No Results Text -->
        <v-list-item v-if="initialSearch && !loading && !hasItems">
            <v-list-item-content>
                <v-list-item-subtitle class="text-center">
                    No results
                </v-list-item-subtitle>
            </v-list-item-content>
        </v-list-item>

        <!--@slot prepend-->
        <v-list-item v-if="hasItems" :to="resultsUrl" class="v-list-item--active">
            <v-list-item-content>
                <v-list-item-subtitle>
                    See full results...
                </v-list-item-subtitle>
            </v-list-item-content>
        </v-list-item>

        <!-- Items -->
        <template v-for="(results, type) in itemsFormatted">
            <!-- Title -->
            <v-subheader :key="type">
                {{ formatAsTitle(type) }}
            </v-subheader>
            <template v-for="item in results">
                <!-- Search Item -->
                <search-item
                    :key="`${type}_${item.id}`"
                    :item="item"
                ></search-item>
            </template>
            <!-- Divider -->
            <v-divider :key="`${type}_divider`"></v-divider>
        </template>
    </v-list>
</template>

<script>
    import {formatAsTitle} from '@core/utils/string'
    import {isEmpty, isNumber, mapValues} from 'lodash'
    import {SEARCH} from '@/router/search/route-names'
    // Components
    import SearchItem from './SearchItem'

    export default {
        name: 'SearchList',
        data: () => ({
            initialSearch: false
        }),
        components: {
            SearchItem
        },
        props: {
            /**
             * The list of search results grouped by type
             * i.e. {customer: [{id: number, title: string, description: string}]}
             */
            items: {
                type: Object,
                default: () => ({})
            },
            /**
             * Toggle the loading spinner
             */
            loading: {
                type: Boolean,
                default: false
            },
            /**
             * The number of items to show per section
             */
            limit: {
                type: Number,
                required: false
            },
            /**
             * The search term used for the results
             */
            term: {
                type: String,
                required: true
            }
        },
        computed: {
            itemsFormatted () {
                const vm = this

                return mapValues(vm.items, (val) => {
                    if (isNumber(vm.limit) && vm.limit > 0) {
                        return val.slice(0, vm.limit)
                    }

                    return val
                })
            },
            hasItems () {
                return !isEmpty(this.items)
            },
            resultsUrl () {
                const vm = this
                return {name: SEARCH, query: {term: vm.term}}
            }
        },
        methods: {
            formatAsTitle
        },
        created () {
            const vm = this
            const unwatch = this.$watch('loading', (newVal, oldVal) => {
                if (oldVal && !newVal) {
                    vm.initialSearch = true
                    unwatch()
                }
            })
        }
    }
</script>
